import React from 'react';
import Svg, { Ellipse, Path, Rect } from 'react-native-svg';

const UnableToLoad = () => (
  <Svg width="183" height="161" viewBox="0 0 183 161" fill="none">
    <Path
      d="M44.0698 9.32422V17.0629"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Path
      d="M40.2202 13.1934H47.9202"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Ellipse cx="64.0698" cy="12.792" rx="1.75" ry="1.75879" fill="#D9D9D9" />
    <Path
      d="M74.4059 41.2495C92.1486 48.8897 98.6747 49.9103 115.337 47.6497C140.076 44.2968 165.626 58.9677 158.314 88.4815C152.689 111.18 133.34 132.201 114.499 136.082C82.7711 142.618 42.0453 123.549 26.2636 95.2629C12.6567 70.8787 19.7534 43.1779 41.6735 35.1108C49.1081 32.3745 57.4122 33.9312 74.4059 41.2495Z"
      fill="#F4F4F4"
    />
    <Path
      d="M159.169 25.0327V32.7714"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Path
      d="M155.319 28.9019H163.019"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Path
      d="M177.169 102.033V109.771"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Path
      d="M173.319 105.902H181.019"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Ellipse cx="172.069" cy="126.792" rx="1.75" ry="1.75879" fill="#D9D9D9" />
    <Rect x="52.5098" y="41" width="82" height="92" rx="12" fill="#D9D9D9" />
    <Path
      d="M78.0982 143.708C73.1463 143.708 69.0947 139.663 69.0947 134.719V62.8075C69.0947 57.8636 73.1463 53.8186 78.0982 53.8186H114.112C116.993 53.8186 119.739 54.9422 121.765 57.0097L137.927 73.1447C139.952 75.1672 141.123 77.9538 141.123 80.8302V134.764C141.123 139.708 137.071 143.753 132.119 143.753H78.0982V143.708Z"
      fill="white"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <Path
      d="M114.112 53.8186V76.2908C114.112 78.7628 116.138 80.7853 118.614 80.7853H141.123"
      fill="white"
    />
    <Path
      d="M114.112 53.8186V76.2908C114.112 78.7628 116.138 80.7853 118.614 80.7853H141.123"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <Path d="M84.1016 103.258H93.1051H84.1016Z" fill="white" />
    <Path d="M100.506 103.258H109.51H100.506Z" fill="white" />
    <Path
      d="M84.1016 103.258H93.1051M100.506 103.258H109.51"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <Path d="M84.1016 85.0005H93.1051H84.1016Z" fill="white" />
    <Path
      d="M84.1016 85.0005H93.1051"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <Path d="M117.112 103.258H126.116H117.112Z" fill="white" />
    <Path
      d="M117.112 103.258H126.116"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <Path d="M84.1016 121.235H93.1051H84.1016Z" fill="white" />
    <Path
      d="M84.1016 121.235H93.1051"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <Path d="M100.51 121.235H109.513H100.51Z" fill="white" />
    <Path
      d="M100.51 121.235H109.513"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <Path d="M117.112 121.235H126.116H117.112Z" fill="white" />
    <Path
      d="M117.112 121.235H126.116"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <Path
      d="M157.45 150.211L141.864 122.845C140.812 120.969 138.416 120.304 136.546 121.379C135.942 121.731 135.416 122.239 135.084 122.845L119.499 150.211C118.427 152.088 119.07 154.472 120.921 155.548C121.525 155.899 122.207 156.075 122.908 156.075H154.079C156.222 156.075 157.976 154.316 157.976 152.166C157.976 151.482 157.8 150.817 157.45 150.211Z"
      fill="white"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <Path d="M138.494 132.619L138.71 145.306L138.494 132.619Z" fill="white" />
    <Path
      d="M138.494 132.619L138.71 145.306"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <Path d="M138.965 148.256H138.984H138.965Z" fill="white" />
    <Path
      d="M138.965 148.256H138.984"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <Path
      d="M68.3385 90.8328H56.3679C50.9178 90.8328 46.5098 86.4594 46.5098 81.083C46.5098 75.6928 50.9318 71.3333 56.3679 71.3333C60.7336 71.3333 64.5642 74.1607 65.8176 78.2974H68.3385C71.8451 78.2974 74.6758 81.097 74.6758 84.5651C74.6758 88.0333 71.8451 90.8328 68.3385 90.8328Z"
      fill="white"
      stroke="#AFAFAF"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
  </Svg>
);

export default UnableToLoad;
